'use client';

import { c as _c } from "react/compiler-runtime";
import { TopBannerDefaults } from './TopBanner.defaults';
import { type TopBannerProps } from './TopBannerProps';
export const TopBanner = t0 => {
  const $ = _c(8);
  const props = t0 === undefined ? TopBannerDefaults : t0;
  const {
    children,
    isSticky,
    backgroundColor,
    textColor,
    height
  } = props;
  const t1 = isSticky ? "fixed" : "absolute";
  let t2;
  if ($[0] !== backgroundColor || $[1] !== height || $[2] !== t1 || $[3] !== textColor) {
    t2 = {
      position: t1,
      backgroundColor,
      color: textColor,
      height
    };
    $[0] = backgroundColor;
    $[1] = height;
    $[2] = t1;
    $[3] = textColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t2) {
    t3 = <div data-builder-component="top-banner" className="top-0 left-0 z-50 flex w-full items-center justify-center py-2" style={t2}>{children}</div>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};